module.exports = __webpack_public_path__ + "static/media/Hair_1.c8350ce7.svg";